
import { Component, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef, TemplateRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ClienteService } from "../cliente.service";
import { Clientes } from "../cliente";
import { Router } from "@angular/router";
import { AlertService } from "ngx-alerts";
import { FormsModule } from "@angular/forms";
import { validarRuc } from '../validar-ruc';
import { validarCedula } from '../validar-cedula';



import Swal from 'sweetalert2';
import {
  MdbTablePaginationComponent,
  MdbTableDirective,
  ModalDirective,
} from "angular-bootstrap-md";
import { ProductoService } from "../producto.service";
import { Producto } from "../producto";
import { Factura } from '../Factura';
import { FacturaService } from '../factura.service';
import { FacturaDetalle } from '../FacturaDetalle';
import { EmisorService } from '../emisor.service';
import { Emisor } from '../emisor';
import { Inventario } from '../inventario';
import { ComprasService } from '../compras.service';
import { Unidades } from '../unidades';
import { UnidadService } from '../unidad.service';
import { ProductoPrecio } from '../productoPrecio';
import { ComprobanteService } from "../comprobante.service";
import { Comprobante } from "../comprobante";
import { formaPago } from "../formaPago";
import { FormaPagoService } from "../forma-pago.service";

import jspdf, { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable'
import { environment } from "../../environments/environment";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { element } from "protractor";
import { ItemsList } from "@ng-select/ng-select/lib/items-list";
import { CuentasxcobrarService } from "../cuentasxcobrar.service";
import { CxC } from "../cxc";
import { UrlWithStringQuery } from "url";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DatePipe } from "@angular/common";
import { VVentas } from "../VVentas";
import { Caja } from "../caja";
import { CajaService } from "../caja.service";
import { cajaDetalle } from "../cajaDetalle";
import { ventasDia } from "../ventasDia";
import { Peso } from "../peso";
import { CanalesService } from "../canales.service";
import { Canales } from "../canales";
@Component({
  selector: "app-facturacion",
  templateUrl: "./facturacion.component.html",
  styleUrls: ["./facturacion.component.scss"],
})
export class FacturacionComponent implements OnInit, AfterViewInit {


  //Cierre de Caja 

  un_centavo: number;
  total_centavos: number
  cinco_centavo: number;
  diez_centavo: number;
  veinticion_centavo: number;
  cincuenta_centavo: number;
  un_dolar: number;
  billete_uno: number;
  billete_cinco: number;
  billete_diez: number;
  billete_veinte: number;
  billete_cincuenta: number;
  billete_cien: number;
  total_caja: number;
  total_efectivo: number;
  total_credito: number;
  total_Ventas_Gastos: number;
  btnCerra: boolean = false;
  btnPanta: boolean = false;
 listaCanales: Canales[] = [];
  total_transferencia: number;
  total_apertura: number;
  total_billete_uno: number;
  total_billete_cinco: number;
  total_billete_diez: number;
  total_billete_veinte: number;
  total_billete_cincuenta: number;
  total_billete_cien: number;
  total_tarjeta: number;
  caja: Caja;
  cajaDetalle: cajaDetalle;
  total_un_dolar: number;
  total_veinticion_centavo: number;
  total_cincuenta_centavo: number;
  total_diez_centavo: number;
  total_cinco_centavo: number;
  total_centavos_centavos: number
  veiniticion_centavo: number;
  cajas: Caja[] = [];
  moneda_un_dolar: number;
  ventasDia: ventasDia[] = [];


  urlImagen: SafeUrl | null = null;
  editForm: FormGroup;
  clienteActual: Clientes;
  clienteNuevo: Clientes;
  cajaNuevo: Caja;
  productoSelecionado: Producto;
  formaPago: string;
  listCliene: Clientes[];
  formaPagoList: formaPago[];
  factura: Factura;

  emisor: Emisor;
  listaClientesActulizar: Clientes[] = [];
  listaProductos: Producto[] = [];
  listaBuscarProducto: Producto[] = [];
  listaCajaAperturada: Caja[] = [];
  listaCajaCerrada: Caja[] = [];
  subTotal: number;
  descTotal: number;
  iva: number;
  total: number;
  observacion: string;
  blod: Blob;
  ruc: string;
  parallevar: boolean;
  porcentajeIva: number;
  pvpPrecio: number;
  efectivo: number;
  tarjeta: number;
  gastos: number;
  gastosTotal: number;
  cambio: number;
  totalDeuda: number
  unidadSelect: number;
  codigLector: string;
  tipoCompra: string;
  selectUnidad: string;
  numeroDocumento: string;
  documento: string;
  comprobante: Comprobante[];
  facturas: Factura[] = [];
  facturasRespuesta: Factura[] = [];
  facturaDetalles: FacturaDetalle[] = [];
  facturaDetalle: FacturaDetalle;
  fecha: Date;
  index: number;
  pesoCantidad: string;
  codigoProducto: string;
  listaCXC: CxC[] = [];
  listaCXCiente: CxC[] = [];
  unidades: Unidades[];
  unidadesVenta: Unidades[] = [];
  fechaDocumento: string;
  listaVentas: VVentas[] = [];
  validaIdentificacion: boolean
  reportServer: string = 'http://myreportserver/reportserver';
  reportUrl: string = 'MyReports/SampleReport';
  showParameters: string = "true";
  parameters: any = {
    "SampleStringParameter": null,
    "SampleBooleanParameter": false,
    "SampleDateTimeParameter": "9/1/2017",
    "SampleIntParameter": 1,
    "SampleFloatParameter": "123.1234",
    "SampleMultipleStringParameter": ["Parameter1", "Parameter2"]
  };
  language: string = "en-us";
  width: number = 100;
  height: number = 100;
  toolbar: string = "true";
  inventario: Inventario;



  @ViewChild(MdbTablePaginationComponent)
  mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
  resul: boolean;

  @ViewChild("processingModal") public mdbModal: ModalDirective;
  @ViewChild("formaPagoModal") public lgFormaPago: ModalDirective;
  @ViewChild('component2') content: ElementRef;
  @ViewChild('content') modalTemplate: TemplateRef<any>;
  @ViewChild('ventas') modalVentas: TemplateRef<any>;
  @ViewChild('contentCierre') cierreCaja: TemplateRef<any>;


  constructor(
    private datePipe: DatePipe,
    private apiFactura: FacturaService,
    private sanitizer: DomSanitizer,
    private apiForma: FormaPagoService,
    private apiCompras: ComprasService,
    private apiEmisor: EmisorService,
    private apiProducto: ProductoService,
    private api: ClienteService,
    private apiCaja: CajaService,
    private apiFac: FacturaService,
    private ruter: Router,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private cdRef: ChangeDetectorRef,
    private apiUnidad: UnidadService,
    private apiCompobante: ComprobanteService,
    private cxc: CuentasxcobrarService,
    private modalService: NgbModal,
    private router: Router,
    private cajaServicio: CajaService,
    private canalesServicio: CanalesService,

  ) { }


  buscarVenta() {
    this.modalService.open(this.modalVentas, { size: 'lg', backdrop: 'static' });


  }



  print(idFac) {


    let url = environment.apiReportes + "factura.rptdesign&__format=pdf&id=" + idFac;
    const WindowPrt = window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');
    WindowPrt.print();
    WindowPrt.close();

  }

  buscarFacturas() {
    if (this.documento.length > 1) {
      this.apiFactura.getVentasxDocumento(this.documento,
        localStorage.getItem("id"))
        .subscribe((
          data: VVentas[]) => {

          this.listaVentas = data;

          this.listaVentas.forEach(element => {
            if (element.tipoDoc === 'F') {
              element.tipoDoc = 'FACTURA';
            }
            if (element.tipoDoc === 'R') {
              element.tipoDoc = 'RECIBO';

            }
            element.numeroFactura = this.PadLeft(element.numeroFactura, 9);
          });

          console.log(this.listaVentas);
          this.mdbTable.setDataSource(this.listaVentas);
          this.mdbTable.dataSourceChange();

        },
          err => this.alertService.danger('Error no hay  conexion..')
        );
    } else {

      this.apiFactura.getVentas(this.datePipe.transform(this.fechaDocumento, "dd-MM-yyyy"),
        localStorage.getItem("id"))
        .subscribe((
          data: VVentas[]) => {

          this.listaVentas = data;

          this.listaVentas.forEach(element => {
            if (element.tipoDoc === 'F') {
              element.tipoDoc = 'FACTURA';
            }
            if (element.tipoDoc === 'R') {
              element.tipoDoc = 'RECIBO';

            }
            element.numeroFactura = this.PadLeft(element.numeroFactura, 9);
          });

          console.log(this.listaVentas);
          this.mdbTable.setDataSource(this.listaVentas);
          this.mdbTable.dataSourceChange();

        },
          err => this.alertService.danger('Error no hay  conexion..')
        );
    }

  }

  listarCXC(ruc: string) {

    this.cxc.getCuentasxCobrar(localStorage.getItem('id'))
      .subscribe((
        data: CxC[]) => {
        this.listaCXC = data;
        this.listaCXC.forEach(element => {
          if (element.tipoDoc === 'F') {
            element.tipoDoc = 'FACTURA';
          }
          if (element.tipoDoc === 'R') {
            element.tipoDoc = 'RECIBO';

          }
          element.numeroDocumento = this.PadLeft(element.numeroDocumento, 9);
        });
        this.listaCXCiente = [];
        this.totalDeuda = 0;
        this.listaCXC.forEach(cxc => {
          if (cxc.identificacion === ruc) {
            this.listaCXCiente.push(cxc);
            this.totalDeuda = this.totalDeuda + cxc.saldo;
          }
        });
        if (this.listaCXCiente.length > 0) {
          this.modalService.open(this.modalTemplate, { size: 'lg', backdrop: 'static' });
          console.log(this.listaCXCiente);
          this.mdbTable.setDataSource(this.listaCXCiente);
          this.mdbTable.dataSourceChange();
        }
        if (this.validarNumeros(this.clienteActual.credito_dolares) > 0) {
          if (this.validarNumeros(this.totalDeuda) > this.validarNumeros(this.clienteActual.credito_dolares)) {
            this.alertService.danger('Cliente sobrepasa credito permitido...')
          }
        }

      }
        , err => {
          console.log(err);

        });
  }

  validarNumeros(numero) {
    if (!numero) {
      return 0;
    } else {
      return numero;
    }
  }

  printDocumento(cxc: CxC) {

    if (cxc.tipoDoc == 'FACTURA') {
      let url = environment.apiReportes + this.emisor.reporteFactura + "&__format=pdf&id=" + cxc.id;
      const WindowPrt = window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');

    } else {
      let url = environment.apiReportes + this.emisor.reporteNotaPedido + "&__format=pdf&id=" + cxc.id;
      const WindowPrt = window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');

    }


  }


  guardarCierre() {

    let total = this.redondearValor(this.total_efectivo) + this.redondearValor(this.total_apertura)
    this.total = this.redondearValor(total)
    this.total_caja = this.redondearValor(this.total_caja)
    this.total_Ventas_Gastos = this.redondearValor(this.total_Ventas_Gastos)
    // if (this.redondearValor(total) == this.redondearValor(this.total_caja)) {



    if (this.redondearValor(this.total) == this.redondearValor(this.total_caja)) {


      this.caja = new Caja()
      this.caja.caja = Number.parseInt(localStorage.getItem("caja"))
      this.caja.total = this.total_caja;
      this.caja.id = 0;
      this.caja.usuario = localStorage.getItem('usuario')
      this.caja.tarjeta = 0;
      this.caja.transferencia = this.total_transferencia
      this.caja.credito = this.total_credito
      this.caja.efectivo = this.total_efectivo
      this.caja.idEmisor = Number.parseInt(localStorage.getItem('id'))
      this.caja.estado = "C"
      this.caja.detalle = new cajaDetalle()
      this.caja.detalle.id = 0
      this.caja.detalle.modedaUno = this.billete_uno
      this.caja.detalle.modela5 = this.cinco_centavo
      this.caja.detalle.moneda10 = this.diez_centavo
      this.caja.detalle.moneda25 = this.veinticion_centavo
      this.caja.detalle.moneda50 = this.cincuenta_centavo
      this.caja.detalle.moneda_centavo = this.un_centavo
      this.caja.detalle.valorUnDolar = this.billete_uno
      this.caja.detalle.valorDolar5 = this.billete_cinco
      this.caja.detalle.valorDolar10 = this.billete_diez
      this.caja.detalle.valorDolar20 = this.billete_veinte
      this.caja.detalle.valorDolar50 = this.billete_cincuenta
      this.caja.detalle.valorDolar100 = this.billete_cien
      this.apiCaja.cerraCaja(this.caja).subscribe(

        data => {
          this.modalService.dismissAll();
          this.validarCajaCerrada();
          let url = environment.apiReportes + "cierre_ventas.rptdesign&__format=pdf&idEmisor=" + localStorage.getItem("id") + "&usuario=" + localStorage.getItem('usuario');
          const WindowPrt = window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');
          this.alertService.success("Se actualizo con exito..");
        },

        error => {
          this.alertService.danger("Caja esta cerrada")
          this.alertService.danger(error)

        }

      );

    } else {
      Swal.fire({
        title: "Alerta....",
        text: "Caja descuadrada total ventas dia $" + this.redondearValor(this.total) + " total cierre $" + this.redondearValor(this.total_caja),
        icon: "warning",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {

        } else {

        }
      });
    }


  }

  validarCajaCerrada() {
    this.cajaServicio.validarCajaCerradaFacturacion(localStorage.getItem('id'),
      localStorage.getItem('usuario'), localStorage.getItem('caja'))
      .subscribe((
        data: Caja[]) => {
        this.listaCajaCerrada = data;

      }
        , err => {

        });
  }



  listarCanales() {

    this.canalesServicio.listarPorEmisorTipo(localStorage.getItem('id'))
      .subscribe((
        data: Canales[]) => {
        this.listaCanales = data;
       
      }
        , err => {
          console.log(err);
        });

  }

  validarAperturaCaja() {
    let cierre = localStorage.getItem('cierre_caja')
    cierre = this.validarCaja(cierre)
    if (cierre == 'S') {
      this.cajaServicio.validarCajaHabiertaFacturacion(localStorage.getItem('id'),
        localStorage.getItem('usuario'), localStorage.getItem('caja'))
        .subscribe((
          data: Caja[]) => {
          this.validarCajaCerrada();
          this.listaCajaAperturada = data;
          if (cierre == 'S' && this.listaCajaAperturada.length > 0) {
            this.total_apertura = this.listaCajaAperturada[0].total

            this.iniciarFacturacion();
          }
          if (cierre == 'S' && this.listaCajaAperturada.length == 0) {
            Swal.fire({
              title: "Alerta....",
              text: "Caja no esta aperturada...",
              icon: "warning",
              confirmButtonText: "Aceptar",
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                this.router.navigate(['/caja'])
              } else {
                this.router.navigate(['/caja'])
              }
            });
          }

        }
          , err => {

          });
    } else {
      this.btnCerra = true;
      this.iniciarFacturacion();
    }
  }


  validarCaja(texto) {
    if (!texto) {
      return 'N';
    } else {
      return texto;
    }
  }

  iniciarFacturacion() {
    this.clienteActual = new Clientes();
    this.emisor = new Emisor();
    this.porcentajeIva = 0.0;
    this.subTotal = 0.0;
    this.descTotal = 0.0;
    this.iva = 0.0;
    this.total = 0.0;
    this.efectivo = 0.0;
    this.tarjeta = 0.0;
    this.cambio = 0.0;
    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ["", Validators.required],
      numeroidentificacion: ["", Validators.required],
      direccion: ["", Validators.required],
      telefonoconvencional: ["", Validators.required],
      celular: ["", Validators.required],
      correo: ["", Validators.required],
      tipoCliente: ["", Validators.required],
      codcliente: [0, Validators.required],
      tipoidentificacion: ["", Validators.required],
      //codigoProducto: ["", Validators.required],
      producto: ["", Validators.required],
    });

    this.listarProveedor();
    this.listarProductoParaBuscar();
    this.listarFormaPago();
    this.listarCanales()
    this.tipoCompra = 'R'
    this.cargarEmisor();
    this.onChangeCompra(this.tipoCompra);
  }

  cargarEmisor(){
     this.apiEmisor.getEmisor(localStorage.getItem('id')).subscribe((data: Emisor[]) => {
      console.log(data);
      data.forEach(item => {
        this.emisor = item;
        console.log(this.emisor);
      });

    });
  }

  ngOnInit() {
    this.limpiarCierre();
    this.validarAperturaCaja();
    this.cargarEmisor();
  }

  onChange1($event: Event) {
    this.editForm.controls.numeroidentificacion.setValue($event);
    this.buscarCedula();
  }

  onChangeArticulo($event: Event) {
    this.buscarProducto();
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();

  }

  onChangeForma(newValue) {
    this.formaPago = newValue;
    this.calcularTotales();
   // this.calcular()
  }

  onChangeCompra(newValue) {
    if (newValue == 'F') {
      this.porcentajeIva = this.emisor.iva;
    } else {
      this.porcentajeIva = 0.0;
    }
    this.apiCompobante.secuenciaComprobante(localStorage.getItem('id'), newValue)
      .subscribe((
        data: Comprobante[]) => {
        this.comprobante = data;
        this.comprobante.forEach(element => {
          this.numeroDocumento = this.PadLeft(element.secuencial, 9);
          this.calcularTotales();
        });
        this.listaProductos.forEach(element => {
          this.onChangeUnidad(element.idUnidad, element);
        });

      }
        , err => {
          console.log(err);

        });

  }

  PadLeft(value, length) {
    return (value.toString().length < length) ? this.PadLeft("0" + value, length) :
      value;
  }


  listarProductoParaBuscar() {
    this.apiProducto.getProducto(localStorage.getItem('id'))
      .subscribe((
        data: Producto[]) => {
        this.listaBuscarProducto = data;

      }
        , err => {
          console.log(err);

        });



  }

  cierre(content) {

    if (this.listaCajaCerrada.length > 0) {
      Swal.fire({
        title: "Alerta....",
        text: "Caja esta cerrada",
        icon: "error",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {

        } else {

        }
      });

    } else {
      this.limpiarCierre();

      this.apiFactura
        .getVentasDia(
          Number.parseInt(localStorage.getItem("id")),
          localStorage.getItem("usuario"),
          Number.parseInt(localStorage.getItem("caja")),
        )
        .subscribe(
          (data: ventasDia[]) => {
            this.ventasDia = data;
            this.ventasDia.forEach(e => {
              if ("EFECTIVO" === e.descripcion) {
                this.total_efectivo = this.redondearValor(e.total)
              }
              if ("CREDITO" === e.descripcion) {
                this.total_credito = this.redondearValor(e.total)
              }
              if ("TRANSFERENCIA" === e.descripcion) {
                this.total_transferencia = this.redondearValor(e.total)
              }
              if ("TARJETA" === e.descripcion) {
                this.total_tarjeta = this.redondearValor(e.total)
              }
            });
            this.modalService.open(content, { size: 'lg' })
          });


    }
  }



  actulizarCliente() {
    this.clienteNuevo = new Clientes();
    this.clienteNuevo.nombrerazonsocial = this.editForm.controls.nombrerazonsocial.value;
    this.clienteNuevo.numeroidentificacion = this.editForm.controls.numeroidentificacion.value;
    this.clienteNuevo.direccion = this.editForm.controls.direccion.value;
    this.clienteNuevo.telefonoconvencional = this.editForm.controls.telefonoconvencional.value;
    this.clienteNuevo.celular = this.editForm.controls.celular.value;
    this.clienteNuevo.tipoCliente = this.editForm.controls.tipoCliente.value;
    this.clienteNuevo.codcliente = this.editForm.controls.codcliente.value;
    this.clienteNuevo.correo = this.editForm.controls.correo.value;
    this.clienteNuevo.tipoidentificacion = 'C';
    this.clienteNuevo.idEmisor = Number(localStorage.getItem("id"));
    this.clienteNuevo.enviado = 'S';
    this.listaClientesActulizar[0] = this.clienteNuevo;

    if (this.clienteNuevo.numeroidentificacion.length <= 10) {
      if (validarCedula(this.clienteNuevo.numeroidentificacion)) {
        this.validaIdentificacion = true;
      }

    }
    if (this.clienteNuevo.numeroidentificacion.length > 10) {
      if (validarRuc(this.clienteNuevo.numeroidentificacion)) {
        this.validaIdentificacion = true;
      }

    }
    if (this.validaIdentificacion == true) {
      this.api.setActulizarCliente(this.listaClientesActulizar).subscribe(

        data => {
          this.alertService.success("Se agrego un nuevo cliente");
          this.mdbModal.hide();
          this.listarProveedor();

        },

        error => {

          this.alertService.danger(error)

        }

      );
    } else {
      this.alertService.danger('Cedula o Ruc incorrectos...');


    }


  }



  actulizarDatosCliente() {
    this.clienteActual.enviado = "S";

    this.listaClientesActulizar[0] = this.clienteActual;

    if (this.clienteActual.numeroidentificacion.length <= 10) {
      if (validarCedula(this.clienteActual.numeroidentificacion)) {
        this.validaIdentificacion = true;
      }

    }
    if (this.clienteActual.numeroidentificacion.length > 10) {
      if (validarRuc(this.clienteActual.numeroidentificacion)) {
        this.validaIdentificacion = true;
      }
    }
    if (this.validaIdentificacion == true) {
      this.api.setActulizarCliente(this.listaClientesActulizar).subscribe(

        data => {
          this.alertService.success("Se agrego un nuevo cliente");
          this.mdbModal.hide();
          this.listarProveedor();

        },

        error => {

          this.alertService.danger(error)

        }

      );
    } else {
      this.alertService.danger('Verifique el ruc o cedula sean correctos');

    }
  }

  pagar() {

    this.grabarFactura();


  }

  grabarFactura() {
    if (this.listaCajaCerrada.length > 0) {
      this.alertService.danger('No puede facturar la caja esta cerrada...');

    } else {
      let validar = false;
      if (this.clienteActual.codcliente == null) {
        validar = true;
        this.alertService.danger('Debe seleccionar el cliente');
      } if (this.tipoCompra == null) {
        validar = true;
        this.alertService.danger('Debe seleccionar tipo Comprobante');
      } if (this.formaPago == null) {
        validar = true;
        this.alertService.danger('Debe seleccionar forma de Pago');
      }

      if (validar == false) {


        this.calcularTotales();
        this.factura = new Factura();
        this.fecha = new Date();
        this.factura.tipoDoc = this.tipoCompra;
        this.factura.id = 0;
        this.factura.numeroFactura = this.numeroDocumento;
        this.factura.total = this.total;
        this.factura.totalConImpuestos = this.total;
        this.factura.idCliente = this.clienteActual.codcliente;
        this.factura.idEmisor = Number(localStorage.getItem('id'));
        this.factura.idFormaPago = Number.parseInt(this.formaPago);
        this.factura.totalIva = this.iva;
        this.factura.totalSinImpuestos = this.subTotal;
        this.factura.enviado = "S"
        this.factura.totalDescuentos = this.descTotal;
        this.factura.valorEfectivo = this.efectivo;
        this.factura.valorTarjeta = this.tarjeta;
        this.factura.observacion = this.observacion;
        if (this.parallevar) {
          this.factura.llevar = 'S'
        } else {
          this.factura.llevar = 'N'
        }
        this.factura.usuario = (localStorage.getItem('usuario'));
        this.factura.establecimiento = (localStorage.getItem('establecimiento'));
        this.facturaDetalles = [];
        this.index = 0;
        this.listaProductos.forEach((item) => {
          this.facturaDetalle = new FacturaDetalle();
          this.facturaDetalle.cantidad = item.cantidad;
          this.facturaDetalle.descripcion = item.nombre;
          this.facturaDetalle.idProducto = item.codigo;
          this.facturaDetalle.costo = item.costo;
          this.facturaDetalle.precioTotalSinImpuestos = item.total;
          if (item.precioDesc > 0) {
            this.facturaDetalle.precioUnitario = item.precioDesc;
          } else {
            this.facturaDetalle.precioUnitario = item.valorUnitario;
          }
          this.facturaDetalle.idUnidad = item.idUnidad;
          this.facturaDetalle.factor = item.factor;
          this.facturaDetalle.descuento = item.desc;
          this.facturaDetalle.enviado = "S";
          this.facturaDetalle.valorIva = item.valorIva;
          //this.facturaDetalle.precioUnitario*this.porcentajeIva;
          this.facturaDetalles[this.index] = this.facturaDetalle;
          this.index++;

        })

        this.factura.det = this.facturaDetalles;
        this.factura.numeroFactura = this.numeroDocumento;
        this.factura.tipoDoc = this.tipoCompra;
        this.factura.caja = Number.parseInt(localStorage.getItem('caja'))
        this.facturas[0] = this.factura;
        this.apiFac.setActulizarFactura(this.facturas).subscribe(
          (data: Factura[]) => {
            this.facturasRespuesta = data;
            let idFac = this.facturasRespuesta[0].id


            this.alertService.info('Se guardo la factura...');
            this.lgFormaPago.hide();
            if (this.factura.tipoDoc == 'F') {
              let url = environment.apiReportes + this.emisor.reporteFactura + "&__format=pdf&id=" + idFac;
              const WindowPrt = window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');

            } else {
              let url = environment.apiReportes + this.emisor.reporteNotaPedido + "&__format=pdf&id=" + idFac;
              const WindowPrt = window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');

            }
            this.tipoCompra = 'R';
            this.ngOnInit_rapido();
            this.limpiar_rapido();
            //const printContent = document.getElementById(cmpName);
            //let doc = new jsPDF();
            //const pdfTable = this.content.nativeElement;
            //     doc.html(printContent, {callback: () => {
            //   doc.output('dataurlnewwindow');
            // }});

            //window.open(URL.createObjectURL(doc.output("blob")));

            //    window.open(URL.createObjectURL(doc.output("blob")));
            //   window.open('', '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');
            //WindowPrt.document.write('');
            // WindowPrt.print();
          },
          error => {

            this.alertService.warning(error);

          }

        );
      }
    }
  }


  limpiar_rapido() {
    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ["", Validators.required],
      numeroidentificacion: ["", Validators.required],
      direccion: ["", Validators.required],
      telefonoconvencional: ["", Validators.required],
      celular: ["", Validators.required],
      correo: ["", Validators.required],
      tipoCliente: ["", Validators.required],
      codcliente: [0, Validators.required],
      tipoidentificacion: ["", Validators.required],
      producto: ["", Validators.required],
      codigoProducto: ["", Validators.required]
    });
    this.total = 0;
    this.subTotal = 0;
    this.iva = 0;
    this.tipoCompra = 'R';
    this.numeroDocumento = null;
    //this.listarProveedor();
    this.listaProductos = [];
    this.total = 0;
    this.descTotal = 0;
    this.iva = 0;
    this.subTotal = 0;


  }


  ngOnInit_rapido() {
    this.limpiarCierre();
    //this.validarAperturaCaja();
    //this.listarUnidadesVenta();
    let varInventario = localStorage.getItem('inventario')



  }

  agregarCliente() {
    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ["", Validators.required],
      numeroidentificacion: ["", Validators.required],
      direccion: ["", Validators.required],
      telefonoconvencional: ["", Validators.required],
      celular: ["", Validators.required],
      correo: ["", Validators.required],
      tipoCliente: ["", Validators.required],
      codcliente: [0, Validators.required],
      tipoidentificacion: ["", Validators.required],
      producto: ["", Validators.required],
    });

    this.mdbModal.show();
  }

  calcular() {
    this.subTotal = 0.0;
    this.iva = 0.0;
    this.total = 0.0;
    this.descTotal = 0.0;
    let valorDes = 0;
    this.listaProductos.forEach((item) => {
      if (this.emisor.descuento === 'P') {
        valorDes =
          item.desc * item.total;
      } else {
        valorDes =
          item.desc;
      }
      item.total = item.total - valorDes;
      item.valdesc = valorDes;
      if (item.iva == "N") {
        item.valorIva = item.total * 0;
      } else {
        //if (this.tipoCompra=='F')
        item.valorIva = item.total * this.porcentajeIva;

      }
      this.subTotal = this.subTotal + item.total;
      this.iva = this.iva + item.valorIva;

    });

    this.listaProductos.forEach((item) => {
      this.descTotal = this.descTotal + item.valdesc;
    });
    //this.iva = this.subTotal * this.porcentajeIva;
    this.total = this.subTotal + this.iva;
  }

  calcularTotales() {
    this.subTotal = 0.0;
    this.iva = 0.0;
    this.total = 0.0;
    this.descTotal = 0.0;
    let valorDes = 0;
    this.listaProductos.forEach((item) => {
      if (item.iva == "N") {
        item.valorIva = item.total * 0;
      } else {
        //if (this.tipoCompra=='F')
        item.valorIva = item.total * this.porcentajeIva;

      }
      this.subTotal = this.subTotal + item.total;
      this.iva = this.iva + item.valorIva;

    });

    this.listaProductos.forEach((item) => {
      this.descTotal = this.descTotal + item.valdesc;
    });
    //this.iva = this.subTotal * this.porcentajeIva;
    this.total = this.subTotal + this.iva;
  }

  valueChangeCantidad(produc: Producto) {
    let valorDes = 0;
    this.productoSelecionado = produc;
    this.productoSelecionado.total =
      this.productoSelecionado.cantidad *
      this.productoSelecionado.valorUnitario;
    if (this.tipoCompra == 'F') {
      this.productoSelecionado.valorIva =
        this.productoSelecionado.total *
        this.porcentajeIva;
    } else {
      this.productoSelecionado.valorIva =
        this.productoSelecionado.total *
        0;
    }
    if (produc.desc !== undefined) {

      if (this.emisor.descuento === 'P') {
        valorDes =
          produc.desc * this.productoSelecionado.total;
      } else {
        valorDes =
          produc.desc;
      }
      this.productoSelecionado.total = this.productoSelecionado.total - valorDes;
      this.productoSelecionado.valdesc = valorDes;
    }

    this.calcularTotales();
    let varInventario = localStorage.getItem('inventario')

    if (this.productoSelecionado.tipoProducto == 'P' && ('N' !== varInventario)) {
      if (this.inventario.cantidad < this.productoSelecionado.cantidad) {
        this.alertService.danger('No hay stock...');
        produc.cantidad = this.productoSelecionado.cantidad;
        this.productoSelecionado.total =
          this.productoSelecionado.cantidad *
          this.productoSelecionado.valorUnitario;
        this.productoSelecionado.total = this.productoSelecionado.total - valorDes;
        this.calcularTotales();
      }
    }
  }

  totalEfectivoCaja() {
    this.total_caja = this.total_centavos + this.total_cinco_centavo +
      this.total_diez_centavo + this.total_veinticion_centavo + this.total_cincuenta_centavo
      + this.total_un_dolar + this.total_billete_uno + this.total_billete_cinco + this.total_billete_diez + this.total_billete_veinte
      + this.total_billete_cincuenta + this.total_billete_cien;
    this.total_caja = this.redondearValor(this.total_caja);
    this.total_Ventas_Gastos = this.total_efectivo - this.gastos;
  }


  valueChangeDesc(produc: Producto) {
    let valorDes = 0;
    this.productoSelecionado = produc;
    this.productoSelecionado.total =
      this.productoSelecionado.cantidad *
      this.productoSelecionado.valorUnitario;

    if (this.emisor.descuento == 'P') {
      valorDes =
        produc.desc * this.productoSelecionado.total;
    } else {
      valorDes = produc.desc * this.productoSelecionado.cantidad;
    }
    this.productoSelecionado.total = this.productoSelecionado.total - valorDes;
    this.productoSelecionado.valdesc = valorDes;
    this.productoSelecionado.precioDesc = this.productoSelecionado.total / this.productoSelecionado.cantidad;
    this.calcularTotales();

  }


  listarProveedor() {
    this.api
      .getClientes(
        localStorage.getItem("id")
      )
      .subscribe(
        (data: Clientes[]) => {
          this.listCliene = data;
          this.listCliene.forEach(element => {
            if (element.numeroidentificacion == '9999999999') {
              this.clienteActual.codcliente = element.codcliente;
              this.editForm.controls.numeroidentificacion.setValue('999999999');
              this.editForm.controls.direccion.setValue(
                element.direccion
              );
              this.editForm.controls.nombrerazonsocial.setValue(
                element.nombrerazonsocial
              );
              this.editForm.controls.numeroidentificacion.setValue(
                element.numeroidentificacion
              );
              this.editForm.controls.correo.setValue(element.correo);
              console.log(this.editForm.controls.correo.value);
            }
          });

          console.log(this.listCliene);
        });
  }


  listarFormaPago() {
    this.apiForma
      .getformaPago(
        localStorage.getItem("id")
      )
      .subscribe(
        (data: formaPago[]) => {
          this.formaPagoList = data;
          this.formaPagoList.forEach(element => {
            if (element.descripcion === 'EFECTIVO') {
              this.formaPago = element.id.toString()
            }
          });
        });
  }

  eliminar(numero: number) {
    //this.removeAllElements( this.listaProductos,numero);

    this.listaProductos.forEach((value, index) => {
      if (value.orden == numero) this.listaProductos.splice(index, 1);
    });

    //this.listaProductos.splice(numero,1);

    this.mdbTable.setDataSource(this.listaProductos);
    this.mdbTable.dataSourceChange();
    this.calcularTotales();
  }

  removeAllElements(array, elem) {
    let index = array.indexOf(elem);
    while (index > -1) {
      array.splice(index, 1);
      index = array.indexOf(elem);
    }
  }


  cobrar() {
    if (this.listaCajaCerrada.length > 0) {
      Swal.fire({
        title: "Alerta....",
        text: "Caja esta cerrada",
        icon: "error",
        confirmButtonText: "Aceptar",

      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {

        } else {

        }
      });
    } else {

      this.efectivo = this.total;
      this.efectivo = this.efectivo.toFixed(2) as unknown as number;
      this.tarjeta = 0;
      this.cambio = 0;
      this.calcularCobro();
      //this.pagar();
      this.lgFormaPago.show();


    }
  }

  calcularCobro() {
    this.cambio = (this.efectivo + this.tarjeta) - this.total;
    this.cambio = this.cambio.toFixed(2) as unknown as number;

  }

  buscarProducto() {

    this.resul = false;
    this.codigLector = this.codigoProducto;
    //const codigoPeso=this.codigLector.split("-",3);
    //if (codigoPeso.length>0){
    //    this.codigoProducto=codigoPeso[0];
    //   this.pesoCantidad=codigoPeso[1]+'.'+codigoPeso[2];
    //}else{
    // this.codigoProducto=this.codigLector;
    // }
    this.codigoProducto = this.codigLector;
    if (this.codigoProducto != null) {
      this.apiProducto
        .getProductoPorCodigo(
          this.codigoProducto,
          localStorage.getItem("id")
        )
        .subscribe(
          (data: Producto[]) => {
            console.log(data);
            data.forEach((item) => {
              this.resul = true;
              this.productoSelecionado = new Producto();
              this.productoSelecionado = item;
            this.productoSelecionado.canalesLista=
             this.listaCanales.filter(a=>a.tipoId==item.tipoId)
             
              if (this.productoSelecionado == null) {
                this.alertService.danger("No existe el producto...");
                this.codigoProducto = "";
              } else {

                if (this.productoSelecionado.tipoProducto == 'P') {

                  this.apiCompras
                    .inventarioProducto(this.productoSelecionado.codigo)
                    .subscribe((dataInv: Inventario) => {
                      console.log(dataInv);
                      this.inventario = dataInv;
                      if (dataInv.cantidad == null) {
                        this.alertService.danger("No hay stock...");
                        this.productoSelecionado.codigoPrincipal = null;
                        this.unidadesVenta = [];
                        this.apiProducto.getProductoPrecio(this.productoSelecionado.codigo.toString(), this.productoSelecionado.idEmisor.toString())
                          .subscribe((
                            varProdcutoPrecio: ProductoPrecio[]) => {
                            this.index = 0;
                            varProdcutoPrecio.forEach(element => {

                              this.apiUnidad.getUnidad(element.idUnidad.toString())
                                .subscribe((
                                  varUnidades: Unidades[]) => {
                                  varUnidades.forEach(elemUnidad => {
                                    elemUnidad.precio = element.precioVenta;
                                    this.unidadesVenta[this.index] = elemUnidad;
                                    this.selectUnidad = elemUnidad.id.toString();
                                    this.productoSelecionado.cantidad = 1;
                                    this.productoSelecionado.desc = 0;
                                    this.onChangeUnidad(this.selectUnidad, this.productoSelecionado)
                                    this.valueChangeDesc(this.productoSelecionado)
                                    this.valueChangeCantidad(this.productoSelecionado)
                                  });
                                  this.index++;

                                }
                                  , err => {
                                    console.log(err);

                                  });



                            });
                            if (varProdcutoPrecio.length > 0) {
                              this.productoSelecionado.unidadesVenta = this.unidadesVenta;
                              this.codigoProducto = ""
                              if (this.pesoCantidad == null) {
                                this.productoSelecionado.cantidad = 1;


                              } else {
                                this.productoSelecionado.cantidad = parseFloat(this.pesoCantidad);
                              }
                              this.productoSelecionado.desc = 0;
                              this.productoSelecionado.cantidad = 1;
                              this.productoSelecionado.total =
                                this.productoSelecionado.cantidad *
                                this.productoSelecionado.valorUnitario;
                              this.productoSelecionado.orden = this.listaProductos.length + 1;
                              this.listaProductos.push(this.productoSelecionado);

                            } else {
                              if (this.productoSelecionado.costo > 0 && this.productoSelecionado.utilidad > 0) {
                                this.productoSelecionado.cantidad = 1;
                                this.productoSelecionado.desc = 0;
                                this.productoSelecionado.valorUnitario = this.productoSelecionado.costo * this.productoSelecionado.utilidad + this.productoSelecionado.costo
                                this.productoSelecionado.total =
                                  this.productoSelecionado.cantidad * this.productoSelecionado.valorUnitario;
                                this.listaProductos.push(this.productoSelecionado);
                                this.valueChangeDesc(this.productoSelecionado)
                              } else {

                                this.alertService.danger("El producto no tiene precio....");
                              }
                            }

                            console.log(varProdcutoPrecio);

                          }
                            , err => {
                              console.log(err);

                            });

                        /*if (confirm('Desea ingresar el producto?')){
      
                        }*/

                      } else {
                        if (dataInv.cantidad > 0) {

                          this.unidadesVenta = [];
                          this.apiProducto.getProductoPrecio(this.productoSelecionado.codigo.toString(), this.productoSelecionado.idEmisor.toString())
                            .subscribe((
                              varProdcutoPrecio: ProductoPrecio[]) => {
                              varProdcutoPrecio.forEach(element => {
                                this.index = 0;
                                this.apiUnidad.getUnidad(element.idUnidad.toString())
                                  .subscribe((
                                    varUnidades: Unidades[]) => {
                                    varUnidades.forEach(elemUnidad => {
                                      elemUnidad.precio = element.precioVenta;
                                      this.unidadesVenta[this.index] = elemUnidad;
                                      this.selectUnidad = elemUnidad.id.toString();
                                      this.productoSelecionado.cantidad = 1;
                                      this.productoSelecionado.precioDesc = 0;
                                      this.onChangeUnidad(this.selectUnidad, this.productoSelecionado)
                                      this.valueChangeDesc(this.productoSelecionado)
                                    });
                                    console.log(varProdcutoPrecio);
                                    this.index++;
                                  }
                                    , err => {
                                      console.log(err);

                                    });



                              });
                              if (varProdcutoPrecio.length > 0) {
                                this.productoSelecionado.unidadesVenta = this.unidadesVenta;

                                this.codigoProducto = "";
                                this.productoSelecionado.desc = 0
                                if (this.pesoCantidad == null) {
                                  this.productoSelecionado.cantidad = 1;


                                } else {
                                  this.productoSelecionado.cantidad = parseFloat(this.pesoCantidad);
                                }

                                this.productoSelecionado.total =
                                  this.productoSelecionado.cantidad *
                                  this.productoSelecionado.valorUnitario;
                                this.productoSelecionado.orden = this.listaProductos.length + 1;
                                this.listaProductos.push(this.productoSelecionado);

                              } else {
                                if (this.productoSelecionado.costo > 0 && this.productoSelecionado.utilidad > 0) {
                                  this.productoSelecionado.desc = 0;
                                  this.productoSelecionado.cantidad = 1;
                                  this.productoSelecionado.valorUnitario = this.productoSelecionado.costo * this.productoSelecionado.utilidad + this.productoSelecionado.costo
                                  this.productoSelecionado.total =
                                    this.productoSelecionado.cantidad * this.productoSelecionado.valorUnitario;
                                  this.productoSelecionado.orden = this.listaProductos.length + 1;
                                  this.listaProductos.push(this.productoSelecionado);
                                  this.valueChangeDesc(this.productoSelecionado)
                                } else {
                                  //  swal("Hello world!");
                                  this.alertService.danger("El producto no tiene precio....");
                                }
                              }



                              console.log(varProdcutoPrecio);

                            }
                              , err => {
                                console.log(err);

                              });
                        } else {

                          this.alertService.danger('No tiene stock....')
                          if (confirm('Producto sin stock desea ingresar.. ')) {

                            let url = `/#/detallecompras`;
                            window.open(url);
                          }

                          this.unidadesVenta = [];
                          this.apiProducto.getProductoPrecio(this.productoSelecionado.codigo.toString(), this.productoSelecionado.idEmisor.toString())
                            .subscribe((
                              varProdcutoPrecio: ProductoPrecio[]) => {
                              this.index = 0;
                              varProdcutoPrecio.forEach(element => {

                                this.apiUnidad.getUnidad(element.idUnidad.toString())
                                  .subscribe((
                                    varUnidades: Unidades[]) => {
                                    varUnidades.forEach(elemUnidad => {
                                      elemUnidad.precio = element.precioVenta;
                                      this.unidadesVenta[this.index] = elemUnidad;
                                      this.selectUnidad = elemUnidad.id.toString();
                                      this.productoSelecionado.cantidad = 1;
                                      this.productoSelecionado.desc = 0;
                                      this.onChangeUnidad(this.selectUnidad, this.productoSelecionado)
                                      this.valueChangeDesc(this.productoSelecionado)
                                      this.valueChangeCantidad(this.productoSelecionado)
                                    });
                                    this.index++;

                                  }
                                    , err => {
                                      console.log(err);

                                    });



                              });
                              if (varProdcutoPrecio.length > 0) {
                                this.productoSelecionado.unidadesVenta = this.unidadesVenta;
                                this.codigoProducto = ""
                                if (this.pesoCantidad == null) {
                                  this.productoSelecionado.cantidad = 1;


                                } else {
                                  this.productoSelecionado.cantidad = parseFloat(this.pesoCantidad);
                                }
                                this.productoSelecionado.desc = 0;
                                this.productoSelecionado.cantidad = 1;
                                this.productoSelecionado.total =
                                  this.productoSelecionado.cantidad *
                                  this.productoSelecionado.valorUnitario;
                                this.productoSelecionado.orden = this.listaProductos.length + 1;
                                this.listaProductos.push(this.productoSelecionado);

                              } else {
                                if (this.productoSelecionado.costo > 0 && this.productoSelecionado.utilidad > 0) {
                                  this.productoSelecionado.cantidad = 1;
                                  this.productoSelecionado.desc = 0;
                                  this.productoSelecionado.valorUnitario = this.productoSelecionado.costo * this.productoSelecionado.utilidad + this.productoSelecionado.costo
                                  this.productoSelecionado.total =
                                    this.productoSelecionado.cantidad * this.productoSelecionado.valorUnitario;
                                  this.listaProductos.push(this.productoSelecionado);
                                  this.valueChangeDesc(this.productoSelecionado)
                                } else {

                                  this.alertService.danger("El producto no tiene precio....");
                                }
                              }

                              console.log(varProdcutoPrecio);

                            }
                              , err => {
                                console.log(err);

                              });


                        }
                      }


                    });
                } else {
                  this.unidadesVenta = [];
                  this.apiProducto.getProductoPrecio(this.productoSelecionado.codigo.toString(), this.productoSelecionado.idEmisor.toString())
                    .subscribe((
                      varProdcutoPrecio: ProductoPrecio[]) => {
                      this.index = 0;
                      varProdcutoPrecio.forEach(element => {

                        this.apiUnidad.getUnidad(element.idUnidad.toString())
                          .subscribe((
                            varUnidades: Unidades[]) => {
                            varUnidades.forEach(elemUnidad => {
                              elemUnidad.precio = element.precioVenta;
                              this.unidadesVenta[this.index] = elemUnidad;
                              this.selectUnidad = elemUnidad.id.toString();
                              this.productoSelecionado.cantidad = 1;
                              this.productoSelecionado.desc = 0;
                              this.onChangeUnidad(this.selectUnidad, this.productoSelecionado)
                              this.valueChangeDesc(this.productoSelecionado)
                              this.valueChangeCantidad(this.productoSelecionado)
                            });
                            this.index++;

                          }
                            , err => {
                              console.log(err);

                            });



                      });
                      if (varProdcutoPrecio.length > 0) {
                        this.productoSelecionado.unidadesVenta = this.unidadesVenta;
                        this.codigoProducto = ""
                        if (this.pesoCantidad == null) {
                          this.productoSelecionado.cantidad = 1;


                        } else {
                          this.productoSelecionado.cantidad = parseFloat(this.pesoCantidad);
                        }
                        this.productoSelecionado.desc = 0;
                        this.productoSelecionado.cantidad = 1;
                        this.productoSelecionado.total =
                          this.productoSelecionado.cantidad *
                          this.productoSelecionado.valorUnitario;
                        this.productoSelecionado.orden = this.listaProductos.length + 1;
                        this.listaProductos.push(this.productoSelecionado);

                      } else {
                        if (this.productoSelecionado.costo > 0 && this.productoSelecionado.utilidad > 0) {
                          this.productoSelecionado.cantidad = 1;
                          this.productoSelecionado.desc = 0;
                          this.productoSelecionado.valorUnitario = this.productoSelecionado.costo * this.productoSelecionado.utilidad + this.productoSelecionado.costo
                          this.productoSelecionado.total =
                            this.productoSelecionado.cantidad * this.productoSelecionado.valorUnitario;
                          this.listaProductos.push(this.productoSelecionado);
                          this.valueChangeDesc(this.productoSelecionado)
                        } else {

                          this.alertService.danger("El producto no tiene precio....");
                        }
                      }

                      console.log(varProdcutoPrecio);

                    }
                      , err => {
                        console.log(err);

                      });

                }
              }
            }

            );
            if (this.resul === false) {
              this.alertService.danger("No existe el producto...");
              this.codigoProducto = "";
            }
          },
          (err) => {
            this.alertService.danger("Problemas con la conexión");
          }
        );

      this.listaProductos.sort((a, b) => (b.orden - a.orden));
      this.mdbTable.dataSourceChange();
      this.mdbTable.setDataSource(this.listaProductos);



      this.calcularTotales();
    }
  }

  peso(entidad: Producto) {
    this.apiFac.getUltimoPeso(localStorage.getItem("id"))
      .subscribe((
        varPeso: Peso[]) => {
        varPeso.forEach(elemUnidad => {
          entidad.cantidad = elemUnidad.peso
          this.valueChangeCantidad(entidad);
        })
      });

  }
  printer(entidad: Producto) {

    let pvp1, pvp2;
    let total1;
    let cantidad1;
    total1 = entidad.total.toFixed(2) as unknown as number;
    cantidad1 = entidad.cantidad.toFixed(2) as unknown as number;
    this.apiUnidad.getUnidad(this.selectUnidad)
      .subscribe((
        varUnidades: Unidades[]) => {
        varUnidades.forEach(elemUnidad => {


          pvp1 = 'PVP($) ' + total1;

          pvp2 = cantidad1 + ' ' + elemUnidad.descripcion
          this.apiProducto.getEtiquetaVenta(entidad.nombre, entidad.codigoPrincipal, pvp2, pvp1).subscribe((file1) => {

            this.blod = new Blob([file1], { type: 'application/pdf' });
            const url1 = window.URL.createObjectURL(this.blod);
            this.urlImagen = this.sanitizer.bypassSecurityTrustUrl(url1);
            var downloadURL = URL.createObjectURL(this.blod);
            window.open(downloadURL);

          }
          );


        });

        this.index++;
      }
        , err => {
          console.log(err);

        });



  }


  onChangeUnidad(newValue, produc: Producto) {
    this.apiProducto.buscarProductoPrecioUnidadProducto(newValue, produc.codigo).subscribe(
      (
        varPrecios: ProductoPrecio[]) => {

        varPrecios.forEach(element => {
          console.log(newValue);
          this.apiUnidad.getUnidad(element.idUnidad.toString()).subscribe(
            (
              varUni: Unidades[]) => {

              varUni.forEach(elementU => {
                console.log(newValue);
                if (this.emisor.preciosIva == 'S' && this.tipoCompra == 'F' && produc.iva == 'S') {
                  let valor = this.emisor.iva.toString().replace('0', '1');
                  produc.valorUnitario = element.precioVenta / Number.parseFloat(valor);
                } else {
                  produc.valorUnitario = element.precioVenta;
                }
                let valorDes=0;
                this.productoSelecionado = produc;
                this.productoSelecionado.factor = elementU.factor;
                this.productoSelecionado.idUnidad = element.idUnidad;

                this.productoSelecionado.total =
                  this.productoSelecionado.cantidad *
                  this.productoSelecionado.valorUnitario;

                if (this.emisor.descuento === 'P') {
                  valorDes =
                    this.productoSelecionado.desc * this.productoSelecionado.total;
                } else {
                  valorDes =
                    this.productoSelecionado.desc;
                }
                this.productoSelecionado.total = this.productoSelecionado.total - valorDes;
                this.productoSelecionado.valdesc = valorDes;

                this.calcularTotales();

              });
            }
            , err => {
              console.log(err);

            });

        });


      }
      , err => {
        console.log(err);

      });

  }




  nuevo() {


    this.limpiar();
    this.listaProductos = [];
    //this.numeroDocumento="";
    //this.tipoCompra==null;
    this.onChangeCompra('R')

  }

  limpiar() {
    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ["", Validators.required],
      numeroidentificacion: ["", Validators.required],
      direccion: ["", Validators.required],
      telefonoconvencional: ["", Validators.required],
      celular: ["", Validators.required],
      correo: ["", Validators.required],
      tipoCliente: ["", Validators.required],
      codcliente: [0, Validators.required],
      tipoidentificacion: ["", Validators.required],
      producto: ["", Validators.required],
      codigoProducto: ["", Validators.required]
    });
    this.total = 0;
    this.subTotal = 0;
    this.iva = 0;
    // this.tipoCompra=null;
    this.tipoCompra = 'R';
    this.numeroDocumento = null;
    this.listarProveedor();
    this.listaProductos = [];
    this.total = 0;
    this.descTotal = 0;
    this.iva = 0;
    this.subTotal = 0;
    this.observacion = "";
  }

  limpiarCierre() {
    this.total_efectivo = 0;
    this.total_caja = 0;
    this.un_centavo = 0;
    this.cinco_centavo = 0;
    this.diez_centavo = 0;
    this.veinticion_centavo = 0;
    this.un_dolar = 0;
    this.cincuenta_centavo = 0;
    this.billete_uno = 0
    this.billete_cinco = 0
    this.billete_diez = 0;
    this.billete_veinte = 0;
    this.billete_cincuenta = 0;
    this.billete_cien = 0;
    this.total_credito = 0;
    this.total_transferencia = 0
    this.gastos = 0;
    this.gastosTotal = 0;
    this.total_tarjeta = 0;
    this.total_centavos = 0;
    this.total_cinco_centavo = 0;
    this.total_diez_centavo = 0;
    this.total_veinticion_centavo = 0;
    this.total_un_dolar = 0;
    this.total_cincuenta_centavo = 0;


    this.total_billete_uno = 0
    this.total_billete_cinco = 0
    this.total_billete_diez = 0;
    this.total_billete_veinte = 0;
    this.total_billete_cincuenta = 0;
    this.total_billete_cien = 0;

  }
  buscarCedula() {
    console.log(this.editForm.controls.numeroidentificacion.value);
    if (this.editForm.controls.numeroidentificacion.value != null) {
      this.api
        .getCliente(
          this.editForm.controls.numeroidentificacion.value,)

        .subscribe(
          (data: Clientes[]) => {
            data.forEach((item) => {
              this.clienteActual = item;
              if (this.clienteActual == null) {
                this.alertService.danger("No existe la cédula o Ruc");
                this.editForm.controls.numeroidentificacion.setValue("");
              } else {
                this.editForm.controls.direccion.setValue(
                  this.clienteActual.direccion
                );
                this.editForm.controls.nombrerazonsocial.setValue(
                  this.clienteActual.nombrerazonsocial
                );
                this.editForm.controls.numeroidentificacion.setValue(
                  this.clienteActual.numeroidentificacion
                );
                this.editForm.controls.correo.setValue(this.clienteActual.correo);
                console.log(this.editForm.controls.correo.value);
                this.listarCXC(item.numeroidentificacion);
              }
            });
            console.log(this.clienteActual);
          },
          (err) => {
            this.alertService.danger("Problemas con la conexión");
          }
        );
    }
  }

  // Cierre




  valorTotalBilleteVeinte() {
    this.total_billete_veinte = 20 * this.billete_veinte;
    this.total_billete_veinte = this.redondear(this.total_billete_veinte);
  }

  valorTotalBilleteCincuenta() {
    this.total_billete_cincuenta = 50 * this.billete_cincuenta;
    this.total_billete_cincuenta = this.redondear(this.total_billete_cincuenta);
  }


  valorTotalBilleteCien() {
    this.total_billete_cien = 100 * this.billete_cien;
    this.total_billete_cien = this.redondear(this.total_billete_cien);
  }

  valorTotalBilleteCinco() {
    this.total_billete_cinco = 5 * this.billete_cinco;
    this.total_billete_cinco = this.redondear(this.total_billete_cinco);
  }

  valorTotalBilleteDiez() {
    this.total_billete_diez = 10 * this.billete_diez;
    this.total_billete_diez = this.redondear(this.total_billete_diez);
  }

  valorTotalBilleteUno() {
    this.total_billete_uno = 1 * this.billete_uno;
    this.total_billete_uno = this.redondear(this.total_billete_uno);
  }
  valorTotalMonedaUnDolar() {
    this.total_un_dolar = 1 * this.un_dolar;
    this.total_un_dolar = this.redondear(this.total_un_dolar);
  }


  valorTotalMonedaCincuenta() {
    this.total_cincuenta_centavo = 0.50 * this.cincuenta_centavo;
    this.total_cincuenta_centavo = this.redondear(this.total_cincuenta_centavo);
  }
  valorTotalMonedaCinco() {
    this.total_cinco_centavo = 0.05 * this.cinco_centavo;
    this.total_cinco_centavo = this.redondear(this.total_cinco_centavo);
  }
  valorTotalCentavos() {
    this.total_centavos = 0.01 * this.un_centavo;
    this.total_centavos = this.redondear(this.total_centavos);
  }
  valorTotalDiez() {
    this.total_diez_centavo = 0.10 * this.diez_centavo;
    this.total_diez_centavo = this.redondear(this.total_diez_centavo);
  }

  valorTotalVeinticinco() {
    this.total_veinticion_centavo = 0.25 * this.veinticion_centavo;
    this.total_veinticion_centavo = this.redondear(this.total_veinticion_centavo);
  }
  redondear(numero: number) {
    this.totalEfectivoCaja();
    return Math.round((numero + Number.EPSILON) * 100) / 100;
  }

  redondearValor(numero: number) {

    return Math.round((numero + Number.EPSILON) * 100) / 100;
  }
}
